import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-3 px-6" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_5 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_6 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_7 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_8 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { key: 1 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from '../components/BranchesLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

import BlockedDate from "@/classes/BlockedDate";
import throttle from "lodash/throttle";

import { paginatePage } from '@/helpers/PageHelper';
import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref, watch, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
/**
 * ********************************
 * Data 
 * ********************************
 */
const loader           = ref(false);
const seletected       = ref();
const errorMsg         = ref(null);
const showError        = ref(false);
const showConfirmation  = ref(false);
const showSuccess      = ref(false);
const branchId         = ref(route.params.id as unknown as string)
const mainRoute        = ref(`/branches/${branchId.value}/blocked-dates`);

const currentRoutePath = computed(() => router.currentRoute.value.path);

const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();
const tab        = ref('all');


const tabs: { name: string, count: number, href: string, allowed: boolean }[] = computed(() => [
    {
        name: 'Active',
        count: active_count.value,
        href: mainRoute.value,
        allowed: true
    },
    {
        name: 'Archived',
        count: archived_count.value,
        href: `${mainRoute.value}/archived`,
        allowed: true
    },
    {
        name: 'Activity logs',
        count: log_counts.value,
        href: `${mainRoute.value}/logs`,
        allowed:
            window.$hasPermission('view-activity-logs')
    }
]);

const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Reason' },
    { text: 'Blocked Date'},
    { text: 'Blocked Time'},
    { text: 'Date Created'}
];

/**
 * ********************************
 * Page Renderer Data 
 * ********************************
 */
const items           = ref(null);
const items_count     = ref(null);
const rows            = ref(null);
const query           = ref(null);
const selected_tab    = ref(null);
const filterDate       = ref(null);
const log_event       = ref(null);
const log_query       = ref(null);
const log_date        = ref(null);
const active_count    = ref(null);
const archived_count  = ref(null);
const log_counts      = ref(null);
const logs            = ref(null);
const log_event_lists = ref(null);

/**
 * ********************************
 * Methods
 * ********************************
 */
const indexBlockedDate = async (data: string) => {

    try {
        loader.value = true;
        const queryString     = searchText.value ? `&query=${searchText.value}` : 'query';
        const dateQuery       = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const isArchivedRoute = currentRoutePath.value === `${mainRoute.value}/archived`;
        const tabValue        = isArchivedRoute ? 'archived' : tab.value;
        const goToPageValue   = paginatePage(data);

        const response = await BlockedDate.indexBlockedDate(branchId.value, `${goToPageValue}&tab=${tabValue}&${queryString}&${dateQuery}`)

        loader.value = false;

        items.value           = response.data.items;
        items_count.value     = response.data.items_count
        rows.value            = response.data.rows
        query.value           = response.data.query
        selected_tab.value    = response.data.selected_tab
        filterDate.value       = response.data.filterDate
        log_event.value       = response.data.log_event
        log_query.value       = response.data.log_query
        log_date.value        = response.data.log_date
        active_count.value    = response.data.active_count
        archived_count.value  = response.data.archived_count
        log_counts.value      = response.data.logs.total
        logs.value            = response.data.logs
        log_event_lists.value = response.data.log_event_lists

    }catch(error){
        loader.value = false;
        showError.value = true;
        errorMsg.value = error.response.data.message;
        
        if(error.response.status == 401) {
            window.location.replace('/login');
        }
    }

}

/**
 * ********************************
 * Methods 
 * ********************************
 */
const applyFilters = () => {
    indexBlockedDate(goToPage.value)
}

const searchData = (val: string) => {
    searchText.value = val
}

/**
 * ********************************
 * Archive
 * ********************************
 */
 const selectedBlockedDate = (id: string) => {
    showConfirmation.value = true
    seletected.value = id
}

const archiveBlockedDate = async () => {
    try {
        loader.value = true;
        await BlockedDate.deleteBlockedDate(seletected.value);
        loader.value = false;
        window.location.replace(`${mainRoute.value}/archived`);
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Restore 
 * ********************************
 */
 const restoreBlockedDate = async (id: string) => {
    try {
        loader.value = true;
        await BlockedDate.restoreBlockedDate(id);
        loader.value = false;
        window.location.replace(mainRoute.value)
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Export 
 * ********************************
 */
 const exportData = async () => {
    try {
        loader.value = true;
        const queryString = searchText.value ? `&query=${searchText.value}` : '';
        const dateQuery   = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const params      = currentRoutePath.value == `${mainRoute.value}/archived` ? 'tab=archived' : 'tab=all';

        await BlockedDate.exportBlockedDate(`${params}&branch_id=${branchId.value}${queryString}${dateQuery}`);

        showSuccess.value = true;
    } catch (error) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

watch(
      searchText,
      throttle(() => {
        indexBlockedDate(goToPage.value)
      }, 1000)
    );

onMounted( () => indexBlockedDate(goToPage.value));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Block Date",
    "show-back": "",
    backUrl: `/branches/edit/${branchId.value}`
  }, {
    default: _withCtx(() => [
      _createVNode(BranchesLayout, { "branch-id": branchId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(TabComponent, {
              tabs: tabs.value,
              "button-items": true
            }, {
              buttons: _withCtx(() => [
                _createVNode(ButtonComponent, {
                  class: "text-gray-900",
                  secondary: "",
                  exportBtn: "",
                  onClick: exportData,
                  disabled: loader.value
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Export ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                (_ctx.$hasPermission('create-blocked-date'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      createBtn: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/branches/${branchId.value}/blocked-dates/create`)))
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Create ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["tabs"])
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FilterComponent, {
              search: searchText.value,
              "text-filters": currentRoutePath.value !== `${mainRoute.value}/logs`,
              onFetchData: searchData,
              "onUpdate:filters": applyFilters,
              "custom-filters": activeTab.value !== 'activity_logs'
            }, {
              fields: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(DatePicker, {
                    id: "filterDate",
                    name: "filterDate",
                    range: "",
                    is24: "",
                    isPresetRanges: "",
                    modelValue: filterDate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDate).value = $event)),
                    placeholder: "Start Date & End Date",
                    label: "Start Date & End Date"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["search", "text-filters", "custom-filters"])
          ]),
          (currentRoutePath.value !== `${mainRoute.value}/logs`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(DataTable, {
                  headers: headers,
                  count: items.value?.data.length
                }, {
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString(item.id), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item.reason), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(item.formatted_blocked_date), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(new Date(`2000-01-01T${item.start_time}`).toLocaleTimeString([], { hour: '2-digit', minute:'2-digit' })) + " - " + _toDisplayString(new Date(`2000-01-01T${item.end_time}`).toLocaleTimeString([], { hour: '2-digit', minute:'2-digit' })), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.formatted_created_at), 1),
                        _createElementVNode("td", _hoisted_9, [
                          (_ctx.$hasPermission('update-blocked-date'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 0,
                                "edit-btn": "",
                                onClick: ($event: any) => (_unref(router).push(`/branches/${branchId.value}/blocked-dates/edit/${item.id}`))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!item.deleted_at && _ctx.$hasPermission('archive-blocked-date'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 1,
                                "delete-btn": "",
                                onClick: ($event: any) => (selectedBlockedDate(item.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (item.deleted_at && _ctx.$hasPermission('restore-blocked-date'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 2,
                                "restore-btn": "",
                                onClick: ($event: any) => (restoreBlockedDate(item.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("template", null, [
                      _createTextVNode(" p. ")
                    ], -1))
                  ]),
                  _: 1
                }, 8, ["count"]),
                _createVNode(PagePagination, {
                  class: "mb-6",
                  items: items.value,
                  onNextPage: indexBlockedDate
                }, null, 8, ["items"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(ActivityLogsTable, {
                  logs: logs.value,
                  onFetchIndex: indexBlockedDate
                }, null, 8, ["logs"])
              ]))
        ]),
        _: 1
      }, 8, ["branch-id"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => {showConfirmation.value = false; archiveBlockedDate() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Archive Blocked Date ?",
        content: "Are you sure you wish to archive this Blocked Date ?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Company Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})